import React from 'react'

const LockIcon = ({color = 'currentColor', width = 20, height = 20, ...rest}) => (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
        <g clipPath="url(#clip0_lock)">
            <path
                d="M14.9997 6.66732H14.1663V5.00065C14.1663 2.70065 12.2997 0.833984 9.99967 0.833984C7.69967 0.833984 5.83301 2.70065 5.83301 5.00065V6.66732H4.99967C4.08301 6.66732 3.33301 7.41732 3.33301 8.33398V16.6673C3.33301 17.584 4.08301 18.334 4.99967 18.334H14.9997C15.9163 18.334 16.6663 17.584 16.6663 16.6673V8.33398C16.6663 7.41732 15.9163 6.66732 14.9997 6.66732ZM7.49967 5.00065C7.49967 3.61732 8.61634 2.50065 9.99967 2.50065C11.383 2.50065 12.4997 3.61732 12.4997 5.00065V6.66732H7.49967V5.00065ZM14.9997 16.6673H4.99967V8.33398H14.9997V16.6673ZM9.99967 14.1673C10.9163 14.1673 11.6663 13.4173 11.6663 12.5007C11.6663 11.584 10.9163 10.834 9.99967 10.834C9.08301 10.834 8.33301 11.584 8.33301 12.5007C8.33301 13.4173 9.08301 14.1673 9.99967 14.1673Z"
                fill={color}
            />
        </g>
        <defs>
            <clipPath id="clip0_lock">
                <rect width="20" height="20" fill="white" />
            </clipPath>
        </defs>
    </svg>
)

export default LockIcon
